import React, { useState, useEffect } from 'react';
import image from '../images/a347ce99-9901-4361-953e-f3306909469c.JPG';
import nuanceColor from '../images/nuancecolor.png'
import { Link } from 'react-router-dom';
import {APIProvider, ControlPosition, Map} from '@vis.gl/react-google-maps';

import {CustomMapControl} from './map-control';
import MapHandler from './map-handler';

function WeddingRSVPForm() {
  const [formData, setFormData] = useState({
    id: '', // ID unique requis
    name: '',
    surname: '',
    email: '',
    phone: '',
    address: '',
    number_of_guests: 0,
    dietary_restrictions: '',
    question: '',
    attending_dinner_cocktail: true,
    attending_brunch: true,
    interested_in_shuttle: false,
  });

  const [guestDetails, setGuestDetails] = useState(Array.from({ length: 1 }, () => ({ guest_name: '', guest_surname: '' })));
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [recaptchaKey, setRecaptchaKey] = useState(null);


  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch('/api/config');
        if (!response.ok) throw new Error('Failed to fetch config');
        
        const config = await response.json();
        setRecaptchaKey(config.RECAPTCHA_SITE_KEY);
      } catch (error) {
        console.error("Error fetching config:", error);
      }
    };
  
    fetchConfig();
  }, []);
  
  // Effet pour synchroniser selectedPlace avec formData.address
  useEffect(() => {
    if (selectedPlace && selectedPlace.formatted_address) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        address: selectedPlace.formatted_address,
      }));
    }
  }, [selectedPlace]);

  // Gestion des changements dans les champs du formulaire
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Détecter si "attending_dinner_cocktail" est décoché
    if (name === 'attending_dinner_cocktail' && !checked) {
      const confirmResult = window.confirm(
        "Vous êtes sûr(e) de ne pas participer au dîner et cocktail ? Vous pouvez changer d'avis plus tard."
      );
      if (!confirmResult) {
        return; // Ne pas mettre à jour l'état si l'utilisateur annule
      }
    }

    setFormData({
      ...formData,
      [name]: name === 'number_of_guests' ? parseInt(value, 10) : type === 'checkbox' ? checked : value, // Conversion explicite
      [name]: type === 'checkbox' ? checked : value,
    });

    // Mettre à jour les détails des invités si `number_of_guests` change
    if (name === 'number_of_guests') {
      const numGuests = parseInt(value, 10);
      const updatedGuests = numGuests > 0
        ? Array.from({ length: numGuests }, (_, index) => ({
            guest_name: guestDetails[index]?.guest_name || '',
            guest_surname: guestDetails[index]?.guest_surname || '',
          }))
        : [];
      setGuestDetails(updatedGuests);
    }
  };

  // Gestion des changements pour les noms et prénoms des invités
  const handleGuestChange = (index, field, value) => {
    const updatedGuests = [...guestDetails];
    updatedGuests[index] = {
      ...updatedGuests[index],
      [field]: value,
    };
    setGuestDetails(updatedGuests);
  };

  // Gestion de la soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Obtenez le jeton reCAPTCHA v3
      if (!recaptchaKey) {
        setError("Impossible de charger la clé reCAPTCHA. Veuillez réessayer plus tard.");
        console.error("reCAPTCHA key is missing from /api/config.");
        return;
      }
      
      const recaptchaToken = await window.grecaptcha.execute(recaptchaKey, { action: 'submit' });

      const dataToSend = {
        ...formData,
        number_of_guests: parseInt(formData.number_of_guests, 10),
        guest_details: guestDetails,
        id: crypto.randomUUID(), // Générer un identifiant unique
        recaptcha_token: recaptchaToken, // Inclure le jeton reCAPTCHA dans les données
      };
  
      const response = await fetch(`/api/submit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      });

      if (response.ok) {
        console.group("Form Submission");
        console.info("Data sent :", JSON.stringify(dataToSend, null, 2));
        console.groupEnd();
        setSubmitted(true);
      } else {
        console.group("Error when submitting form");
        const errorData = await response.text(); // Lire la réponse comme texte brut
        console.error("Error :", errorData);
        console.groupEnd();
        setError("Une erreur s’est produite. Veuillez réessayer.");
      }
    } catch (error) {
      console.error('Issue :', error);
      setError('Issue. Please check your connection.');
    }
  };

  // Rendu des champs conditionnels pour les invités
  const renderGuestFields = () => {
    if (formData.number_of_guests > 0) {
      return guestDetails.map((guest, index) => (
        <div key={index}>
          <p>
            <label>Invité {index + 1} - Prénom</label>
            <input
              type="text"
              name={`guest_${index}_name`}
              value={guest.guest_name}
              onChange={(e) => handleGuestChange(index, 'guest_name', e.target.value)}
              placeholder={`Prénom de l'invité ${index + 1}`}
              required
            />
          </p>
          <p>
            <label>Invité {index + 1} - Nom</label>
            <input
              type="text"
              name={`guest_${index}_surname`}
              value={guest.guest_surname}
              onChange={(e) => handleGuestChange(index, 'guest_surname', e.target.value)}
              placeholder={`Nom de l'invité ${index + 1}`}
              required
            />
          </p>
        </div>
      ));
    }
    return null;
  };

  if (submitted) {
    return (
      <div>
        <div
          className="hero"
          style={{ backgroundImage: `url(${image})`, height: "250px" }}
        >
          <div className="hero-inner">
            <div className="inner">
              <div className="hero-line-one">
                Confirmation de Présence au Mariage
              </div>
            </div>
            <Link className="more-arrow" to="#content">
              <i className="fa fa-chevron-down"></i>
              <span>Scroll Down</span>
            </Link>
          </div>
        </div>
        <div className="wrap full-wrap">
          <div className="main-wrap">
            <section className="main">
              <div className="inner">
                <h2>Merci, nous avons bien reçu tes informations !</h2>
                {formData.attending_dinner_cocktail ? (
                  <div>
                    <p><h4 style={{color: '#f08c79'}}>Nous sommes ravis de savoir que tu seras parmi nous pour le dîner et le cocktail. Cela promet d’être une soirée mémorable ! Pour nous faire un petit clin d'œil, une touche de pêche, terracotta ou bleu céladon dans ta tenue serait géniale !</h4></p>
                    <p><img src={nuanceColor} alt='nuancier' style={{maxWidth: '50%', marginLeft: '25%'}}></img></p>
                  </div>
                ) : (
                  <p>
                    C'est dommage que tu ne puisses pas te joindre à nous pour le dîner et le cocktail. Nous espérons te revoir bientôt ! 
                    <br />
                    Si jamais tu changes d'avis, n'hésite pas à soumettre le formulaire à nouveau. 😊
                  </p>
                )}
                <p><strong>Voici un résumé des informations soumises :</strong></p>
                <table style={{ width: '100%', borderCollapse: 'collapse', margin: '20px 0' }}>
                  <thead>
                    <tr>
                      <th style={{ border: '1px solid #ddd', padding: '8px' }}>Champ</th>
                      <th style={{ border: '1px solid #ddd', padding: '8px' }}>Valeur</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>Prénom</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{formData.name}</td>
                    </tr>
                    <tr>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>Nom</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{formData.surname}</td>
                    </tr>
                    <tr>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>Email</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{formData.email}</td>
                    </tr>
                    <tr>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>Téléphone</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{formData.phone}</td>
                    </tr>
                    <tr>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>Adresse</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{formData.address || 'Non renseignée'}</td>
                    </tr>
                    <tr>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>Nombre de personnes</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{formData.number_of_guests}</td>
                    </tr>
                    <tr>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>Restrictions alimentaires</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{formData.dietary_restrictions || 'Aucune'}</td>
                    </tr>
                    <tr>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>Question</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{formData.question || 'Aucune'}</td>
                    </tr>
                    <tr>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>Dîner & Cocktail</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                        {formData.attending_dinner_cocktail ? 'Oui' : 'Non'}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>Brunch</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                        {formData.attending_brunch ? 'Oui' : 'Non'}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>Navette</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                        {formData.interested_in_shuttle ? 'Oui' : 'Non'}
                      </td>
                    </tr>
                    {guestDetails.map((guest, index) => (
                      <React.Fragment key={index}>
                        <tr>
                          <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                            Invité {index + 1} - Prénom
                          </td>
                          <td style={{ border: '1px solid #ddd', padding: '8px' }}>{guest.guest_name}</td>
                        </tr>
                        <tr>
                          <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                            Invité {index + 1} - Nom
                          </td>
                          <td style={{ border: '1px solid #ddd', padding: '8px' }}>{guest.guest_surname}</td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div
        className="hero"
        style={{ backgroundImage: `url(${image})`, height: "250px" }}
      >
        <div className="hero-inner">
          <div className="inner">
            <div className="hero-line-one">
              Confirmation de Présence au Mariage
            </div>
          </div>
          <Link className="more-arrow" to="#content">
            <i className="fa fa-chevron-down"></i>
            <span>Scroll Down</span>
          </Link>
        </div>
      </div>

      <div className="wrap full-wrap">
          <div className="main-wrap">
            <section className="main">
              <div className="inner" style={{paddingTop: '0px'}}>
                <h2>Donnez nous quelques informations pour nous aider à organiser le mariage et vous contacter plus facilement: </h2>
                <form onSubmit={handleSubmit}>
                  <p>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder='Prénom*'
                      required
                    />
                  </p>

                  <p>
                    <input
                      type="text"
                      name="surname"
                      value={formData.surname}
                      onChange={handleChange}
                      placeholder='Nom*'
                      required
                    />
                  </p>

                  <p>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Email*"
                      required
                    />
                  </p>

                  <p>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Téléphone*"
                      required
                    />
                  </p>

                  <div style={{height: '450px'}}>
                    <APIProvider apiKey="AIzaSyBB7MyXGdSpExnHtVwkdRk4cY0YHf5ANVw">
                      <Map
                        defaultZoom={5}
                        defaultCenter={{ lat: 46.8041, lng: 1.70 }}
                        gestureHandling={"greedy"}
                        disableDefaultUI={true}
                      />

                      <CustomMapControl
                        controlPosition={ControlPosition.TOP_LEFT}
                        onPlaceSelect={setSelectedPlace}
                      />

                      <MapHandler
                        place={selectedPlace}
                      />
                    </APIProvider>
                  </div>

                  <p>
                    <label>
                      <input
                        type="checkbox"
                        name="attending_dinner_cocktail"
                        checked={formData.attending_dinner_cocktail}
                        style={{marginRight: '10px', marginBottom: '5px'}}
                        onChange={handleChange}
                      />
                      Je participerai au dîner et cocktail
                    </label>
                  </p>

                  {/* Affichage conditionnel des champs */}
                  {formData.attending_dinner_cocktail && (
                      <>
                        <p>
                          <label>
                            <input
                              type="checkbox"
                              name="attending_brunch"
                              checked={formData.attending_brunch}
                              style={{marginRight: '10px', marginBottom: '5px'}}
                              onChange={handleChange}
                            />
                            Je participerai au brunch le lendemain
                          </label>
                        </p>

                        <p>
                          <label>
                            <input
                              type="checkbox"
                              name="interested_in_shuttle"
                              checked={formData.interested_in_shuttle}
                              style={{marginRight: '10px', marginBottom: '5px'}}
                              onChange={handleChange}
                            />
                            Je suis intéressé(e) par une navette pour rentrer samedi soir
                          </label>
                        </p>

                        <p>
                          <label>Nombre de personnes :</label>
                          <input
                            type="number"
                            name="number_of_guests"
                            value={formData.number_of_guests}
                            onChange={handleChange}
                            min="0"
                            style={{marginLeft: '10px'}}
                            required
                          />
                        </p>

                        {/* Champs pour chaque invité */}
                        {renderGuestFields()}

                        <p>
                          <input
                            type="text"
                            name="dietary_restrictions"
                            value={formData.dietary_restrictions}
                            onChange={handleChange}
                            placeholder="Restrictions alimentaires (optionnel)"
                          />
                        </p>

                        <p>
                          <textarea
                            name="question"
                            value={formData.question}
                            onChange={handleChange}
                            placeholder='Une question ? (optionnel)'
                          />
                        </p>
                      </>
                    )}

                {error && <p style={{ color: "red" }}>{error}</p>}
                <button type="submit">Confirmer</button>
              </form>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default WeddingRSVPForm;
